import { ROLE } from "./constants";

export const navbarMenuList = [
    {label:'explore',value:'Explore',href:'/gallery/explore',role:ROLE.AUDIENCE},
    {label:'following',value:'Following',href:'/gallery/following',role:ROLE.AUDIENCE},
    {label:'mylikes',value:'My Likes',href:'/gallery/mylikes',role:ROLE.AUDIENCE},
    {label:'my-subscriptions',value:'My Subscriptions',href:'/gallery/my-subscriptions',role:ROLE.AUDIENCE},
    {label:'frame',value:'My Frame',href:'/gallery/my-frame',role:ROLE.AUDIENCE},

    {label:'uploads',value:'My Uploads',href:'/gallery/uploads',role:ROLE.ARTIST},
    {label:'subscriptions',value:'Subscriptions',href:'/gallery/subscriptions',role:ROLE.ARTIST},
    {label:'dashboard',value:'Dashboard',href:'/gallery/dashboard',role:ROLE.ARTIST},
    {label:'artwork-management',value:'Artwork Management',href:'/gallery/artwork-management',role:ROLE.ARTIST},

    {label:'explore',value:'Explore',href:'/gallery/explore',role:ROLE.GUEST},

]
